import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./viewport_hero_with_cta.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
